export default __webpack_public_path__ + "static/Miscellaneous-Demolition-f0ed5110e1435e2c8d3c77d09f2dd8f6.jpg";